import React from 'react';
import { Box, Typography } from '@mui/material';
import StarIcon from '@mui/icons-material/Star';

const levelStyles = {
	FAN: {
		position: 'relative',
		'&:after': {
			content: '""',
			position: 'absolute',
			bottom: '100%',
			left: '50%',
			transform: 'translateX(-50%)',
			width: 0,
			height: 0,
			borderLeft: '8px solid transparent',
			borderRight: '8px solid transparent',
			borderBottom: '8px solid black',
		},
	},
	ELITE: {
		position: 'relative',
		'&:after': {
			content: '""',
			position: 'absolute',
			bottom: '100%',
			left: '50%',
			transform: 'translateX(-50%)',
			width: 0,
			height: 0,
			borderLeft: '8px solid transparent',
			borderRight: '8px solid transparent',
			borderBottom: '8px solid black',
		},
	},
	VIP: {
		position: 'relative',
		'&:after': {
			content: '""',
			position: 'absolute',
			bottom: '100%',
			left: '50%',
			transform: 'translateX(-50%)',
			width: 0,
			height: 0,
			borderLeft: '8px solid transparent',
			borderRight: '8px solid transparent',
			borderBottom: '8px solid black',
		},
	},
};

interface CustomProgressBarProps {
	level: 'FAN' | 'ELITE' | 'VIP';
}

const CustomProgressBar: React.FC<CustomProgressBarProps> = ({ level }) => {
	const getSegmentStyles = (index: any): any => {
		const filled =
			level === 'VIP' || (level === 'ELITE' && index < 2) || (level === 'FAN' && index === 0);

		return {
			width: '33.33%',
			height: '20px',
			backgroundColor: filled ? '#0064C7' : '#e0e0e0',
			position: 'relative',
			display: 'flex',
			alignItems: 'center',
			justifyContent: 'center',
			borderRadius: index === 0 ? '4px 0 0 4px' : index === 2 ? '0 4px 4px 0' : '0',
			borderRight: index < 2 ? '1px solid white' : 'none',
		};
	};

	return (
		<Box sx={{ width: '100%' }}>
			<Box
				sx={{
					display: 'flex',
					width: '100%',
					height: '20px',
					borderRadius: '40px',
					overflow: 'hidden',
				}}
			>
				{[0, 1, 2].map((index) => (
					<Box key={index} sx={getSegmentStyles(index)}>
						{level === 'VIP' || level === 'ELITE' || (level === 'FAN' && index === 0) ? (
							<StarIcon sx={{ color: 'white', position: 'absolute', height: '15px' }} />
						) : null}
					</Box>
				))}
			</Box>
			<Box sx={{ display: 'flex', justifyContent: 'space-between', marginTop: '8px' }}>
				{['FAN', 'ELITE', 'VIP'].map((currentLevel) => (
					<Box
						key={currentLevel}
						sx={{
							position: 'relative',
							...(level === currentLevel ? levelStyles[currentLevel] : {}),
							'& span': {
								backgroundColor: level === currentLevel ? 'black' : 'transparent',
								color: level === currentLevel ? 'white' : 'inherit',
								padding: '4px 8px',
								borderRadius: '4px',
								fontWeight: level === currentLevel ? 'bold' : 'normal',
							},
						}}
					>
						<Typography variant="caption">{currentLevel}</Typography>
					</Box>
				))}
			</Box>
		</Box>
	);
};
export default CustomProgressBar;
